import React from "react";
import styled from "styled-components";

import { useModal } from "@examspark/common-app";
import { Button } from "@examspark/common-ui";

import RedirectToCampfireModal from "../../../redirect/RedirectToCampfireModal";

const Styled = styled.div`
  font-family:
    "Nunito",
    sans-serif,
    "roboto-slab",
    proxima-nova,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;

  border: solid 1px #ddd;
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  line-height: 1.5em;

  ul {
    padding: 0 0 0 2rem;
    margin: 0rem 0;
  }
  li {
    margin: 0.5rem 0;
  }
`;

const StyledBannerHeaderText = styled.div`
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  color: #333;
  border-bottom: solid 1px #ddd;
  padding-bottom: 0.5rem;
`;

const StyledButton = styled(Button)`
  text-align: center;
  background-color: #c79f3c;
  color: white;
  font-weight: 500;
  border-color: #a88530;
  justify-content: center;
  transition:
    background-color 0.3s,
    border-color 0.3s;

  &:hover {
    background-color: #b88a2f;
    border-color: #a88530;
  }
  &:active {
    background-color: #a88530 !important;
    border-color: #a88530 !important;
  }
  &:disabled {
    background-color: #ddd;
    color: #555;
    border-color: #ddd;
  }
  &:disabled:active {
    background-color: #ddd !important;
    border-color: #ddd !important;
  }
`;

const StyledCaveat = styled.div`
  color: #888;
`;

export const CampfireAssessmentBanner = (props: { disabled?: boolean }) => {
  const redirectModal = useModal();

  return (
    <>
      <RedirectToCampfireModal {...redirectModal.modalProps} />
      <Styled>
        <StyledBannerHeaderText>Coming Fall 2025</StyledBannerHeaderText>
        {/* <StyledDivider /> */}
        <div>
          An enhanced digital assessment experience, FREE for all TCMPC
          subscribers, powered by Campfire Learning!
        </div>
        <ul>
          <li>
            <strong>Access</strong> ready-to-use unit & formative assessment
            items aligned to your TCMPC curriculum
          </li>
          <li>
            <strong>Deliver</strong> assessments through the Campfire app or
            your preferred LMS
          </li>
          <li>
            <strong>Connect</strong> your curriculum planning with real-time
            data informed classroom insights
          </li>
          <li>
            <strong>Preview access</strong> available this summer*
          </li>
        </ul>
        <StyledButton
          disabled={props.disabled}
          title="Launch"
          onClick={() => redirectModal.open()}
        >
          Launch Campfire Assessment Preview
        </StyledButton>
        <StyledCaveat>
          * Access limited to select parties at this time.
        </StyledCaveat>
      </Styled>
    </>
  );
};
